module.exports = __webpack_public_path__ + "img/Questions_Desktop.a087265c.svg";